module.exports = __webpack_public_path__ + "static/img/ios3.9179ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios3.jpg
// module id = fEbl
// module chunks = 1